import { render, staticRenderFns } from "./deleteProvider.vue?vue&type=template&id=601df225&lang=pug&"
import script from "./deleteProvider.vue?vue&type=script&lang=js&"
export * from "./deleteProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports